module.exports = __webpack_public_path__ + "img/logo_header_plus.f1f810cb.svg";